// Asylum / removal-defense deep workspace.
// Composition: ClientHero + AISummary + SwimLanes + DocWall (shared) +
// I589Card + DeclarationCard + COICard in a 3-up grid.
// All cards consume matter.workspace.* with empty-state fallbacks so a
// fresh Mongo case without seeded workspace data still renders cleanly.

import type { Client, Matter, PracticeArea } from "../../../data/types";
import { AISummary } from "../AISummary";
import { MatterHero } from "../MatterHero";
import { DocWall } from "../DocWall";
import { SwimLanes } from "../SwimLanes";
import { pick, type COIShape, type DeclarationShape, type I589Shape } from "../workspace-shapes";
import { COICard } from "./COICard";
import { DeclarationCard } from "./DeclarationCard";
import { I589Card } from "./I589Card";
import type { MatterWithClient } from "../../../api/mock";

interface Props {
  matter: Matter;
  client: Client | null | undefined;
  pa: PracticeArea | null;
  templateId: string | null;
}

export function AsylumWorkspace({ matter, client, pa, templateId }: Props) {
  const ws = matter.workspace;
  const i589 = pick<I589Shape>(ws, "i589");
  const declaration = pick<DeclarationShape>(ws, "declaration");
  const coi = pick<COIShape>(ws, "coi");
  const caseId = (matter as Partial<MatterWithClient>).mongoId;

  return (
    <>
      <MatterHero matter={matter} client={client} pa={pa} templateId={templateId} />
      <AISummary summary={matter.aiSummary} caseId={caseId} />
      <SwimLanes matter={matter} pa={pa} />
      <DocWall documents={matter.documents} caseId={caseId} driveFolder={matter.driveFolder} />
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: 14,
        }}
      >
        <I589Card i589={i589} />
        <DeclarationCard declaration={declaration} />
        <COICard coi={coi} />
      </div>
    </>
  );
}
